import { unwrap } from 'api/schema/utils';
export default function parseColors(data) {
    const colors = unwrap(data === null || data === void 0 ? void 0 : data.colors) || [];
    const activeColors = colors.filter((color) => color === null || color === void 0 ? void 0 : color.isActive);
    const inactiveColors = colors.filter((color) => !(color === null || color === void 0 ? void 0 : color.isActive));
    return { colors, activeColors, inactiveColors };
}
